export default __webpack_public_path__ + "static/media/tts_en_star_b1(-6).6b6dff2e.mp3";